import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mobile-guests-drawer"
export default class extends Controller {
  static targets = ["content", "filters", "footer", "icon"]
  static values = { expanded: Boolean }

  connect() {
    // Start collapsed on mobile
    if (window.innerWidth < 1024) {
      this.collapse()
    } else {
      // Always expanded on desktop
      this.expand()
    }

    // Handle window resize
    this.resizeHandler = this.handleResize.bind(this)
    window.addEventListener('resize', this.resizeHandler)
  }

  disconnect() {
    window.removeEventListener('resize', this.resizeHandler)
  }

  handleResize() {
    if (window.innerWidth >= 1024) {
      // Desktop: always show everything
      this.expand()
    } else if (!this.expandedValue) {
      // Mobile: respect collapsed state
      this.collapse()
    }
  }

  toggle(event) {
    if (event) event.preventDefault()

    // Only allow toggle on mobile
    if (window.innerWidth >= 1024) return

    if (this.expandedValue) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    this.expandedValue = true

    // Show content
    if (this.hasContentTarget) {
      this.contentTarget.classList.remove('hidden')
    }

    // Show filters
    if (this.hasFiltersTarget) {
      this.filtersTarget.classList.remove('hidden')
    }

    // Show footer
    if (this.hasFooterTarget) {
      this.footerTarget.classList.remove('hidden')
    }

    // Rotate icon
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove('rotate-180')
    }
  }

  collapse() {
    this.expandedValue = false

    // Hide content
    if (this.hasContentTarget) {
      this.contentTarget.classList.add('hidden')
    }

    // Hide filters
    if (this.hasFiltersTarget) {
      this.filtersTarget.classList.add('hidden')
    }

    // Hide footer
    if (this.hasFooterTarget) {
      this.footerTarget.classList.add('hidden')
    }

    // Rotate icon
    if (this.hasIconTarget) {
      this.iconTarget.classList.add('rotate-180')
    }
  }
}
